import React, { useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { i18n } from '../../translate/i18n';
import ColorModeContext from '../../layout/themeContext';
import { createGradientStyles } from '../../utils/themeColors';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    padding: theme.spacing(2, 3),
    '& .MuiTypography-root': {
      fontWeight: 600,
      fontSize: '1.2rem'
    }
  },
  ...createGradientStyles(theme),
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#fafafa'
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#f5f5f5',
    borderTop: theme.palette.type === 'dark' ? '1px solid #444' : '1px solid #e0e0e0'
  },
}));

const ShowTicketOpen = ({ isOpen, handleClose, user, queue }) => {
  const classes = useStyles();
  const theme = useTheme();
  const colorModeContext = useContext(ColorModeContext);
  const useGradient = colorModeContext?.useGradient || theme.palette?.gradient || false;
  
  return (
    <Dialog 
      open={isOpen} 
      onClose={handleClose}
      scroll="body"
      PaperProps={{
        style: {
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          margin: '32px auto',
          maxHeight: 'calc(100vh - 64px)',
        },
      }}
    >
      <DialogTitle 
        className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}
      >
        {i18n.t("showTicketOpenModal.title.header")}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {user !== undefined && queue !== undefined && (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.message")} <br></br>
            { `${i18n.t("showTicketOpenModal.form.user")}: ${user}`}<br></br>
            {`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}<br></br>
          </DialogContentText>
        )}
        {!user && (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.messageWait")} <br></br>
            {queue && (`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`)}<br></br>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog >
  );
};

export default ShowTicketOpen;
